import React from 'react';
import { ProfileDropdown } from '../components/profileDropdown/ProfileDropdown/ProfileDropdown';
import * as S from '../Header.styles';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import DynamicBreadcrumb from '../components/Breadcrumb/DynamicBreadcrumb';
import { NotificationsDropdown } from '../components/notificationsDropdown/NotificationsDropdown';
import type { RouteConfig } from '@app/components/header/components/Breadcrumb/DynamicBreadcrumb';

interface DesktopHeaderProps {
  isTwoColumnsLayout: boolean;
  routes: RouteConfig[];   // 👈 accept routes as a prop
}

export const DesktopHeader: React.FC<DesktopHeaderProps> = ({ isTwoColumnsLayout, routes }) => {
  const leftSide = isTwoColumnsLayout ? (
    <S.SearchColumn xl={16} xxl={17} lg={14} md={14}>
      <BaseRow>
        <BaseCol xl={15} xxl={12}>
          <DynamicBreadcrumb routes={routes[0]?.children || []} />
        </BaseCol>
      </BaseRow>
    </S.SearchColumn>
  ) : (
    <>
      <BaseCol lg={15} xxl={17}>
        <DynamicBreadcrumb routes={routes[0]?.children || []} />
      </BaseCol>
      <BaseCol />
    </>
  );

  return (
    <BaseRow justify="space-between" align="middle" className="header-bar">
      {leftSide}

      <S.ProfileColumn xl={8} xxl={7} $isTwoColumnsLayout={isTwoColumnsLayout}>
        <BaseRow align="middle" justify="end" gutter={[5, 5]}>
          <BaseCol>
            <BaseRow gutter={[{ xxl: 5 }, { xxl: 5 }]}>
              <BaseCol>
                <NotificationsDropdown />
              </BaseCol>
            </BaseRow>
          </BaseCol>

          <BaseCol>
            <ProfileDropdown />
          </BaseCol>
        </BaseRow>
      </S.ProfileColumn>
    </BaseRow>
  );
};
